import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TrendingUp, Loader2, Lock } from "lucide-react";
import { login, setToken, getToken, formatApiError } from "@/lib/auth";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (getToken()) navigate("/admin", { replace: true });
    }, [navigate]);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const res = await login(email, password);
            setToken(res.access_token);
            navigate("/admin", { replace: true });
        } catch (err) {
            setError(formatApiError(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    const inputCls = "w-full bg-ink border border-white/10 focus:border-gold/60 outline-none px-4 py-3.5 text-sm placeholder:text-slate-600 transition-colors";

    return (
        <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-4 pt-20">
            <div className="w-full max-w-md">
                <div className="flex items-center gap-2.5 justify-center mb-10">
                    <span className="flex items-center justify-center w-9 h-9 bg-gold text-ink">
                        <TrendingUp size={19} strokeWidth={2.5} />
                    </span>
                    <span className="font-serif text-2xl tracking-tight">
                        Investidor <span className="text-gold italic">Comum</span>
                    </span>
                </div>

                <div className="border border-white/10 bg-paper p-8">
                    <div className="flex items-center gap-3 mb-8">
                        <Lock size={16} className="text-gold" />
                        <h1 className="font-serif text-xl">Área da redação</h1>
                    </div>

                    {error && (
                        <div data-testid="admin-login-error" className="mb-5 border border-red-500/40 bg-red-500/10 text-red-400 text-sm px-4 py-3">
                            {error}
                        </div>
                    )}

                    <form data-testid="admin-login-form" onSubmit={submit} className="flex flex-col gap-4">
                        <div>
                            <label className="block text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">E-mail</label>
                            <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@investidorcomum.com.br" className={inputCls} />
                        </div>
                        <div>
                            <label className="block text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">Senha</label>
                            <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputCls} />
                        </div>
                        <button
                            data-testid="admin-login-submit"
                            type="submit"
                            disabled={loading}
                            className="mt-2 bg-gold text-ink font-medium px-8 py-3.5 text-sm hover:bg-golddark transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
                        >
                            {loading && <Loader2 size={15} className="animate-spin" />}
                            Entrar
                        </button>
                    </form>
                </div>
            </div>
        </main>
    );
}
